import { render, staticRenderFns } from "./msw-links.vue?vue&type=template&id=2fe43da5&scoped=true&"
import script from "./msw-links.vue?vue&type=script&lang=ts&"
export * from "./msw-links.vue?vue&type=script&lang=ts&"
import style0 from "./msw-links.vue?vue&type=style&index=0&id=2fe43da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe43da5",
  null
  
)

export default component.exports